import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import ExpandoControl from '../controls/expando-control';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <br />
    <ExpandoControl title="File Upload Guidance" mdxType="ExpandoControl">
      <ul>
  <li>
    The uploaded shapefile must cover the entire works footprint, including all areas impacted during construction.
  </li>
  <li>
    The resultant levy liability only applies to Crown land that hasn't been paid-for, even if the works footprint
    intersects freehold and/or previously paid-for Crown land.
  </li>
  <li>
    The levy liability for any freehold land intersected will be met through payment under a different levy event, if
    not already paid-for.
  </li>
      </ul>
    </ExpandoControl>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      